/**
 * Created by D K Rai on 4/16/2018.
 */
import React, {Component} from 'react';
import moment from 'moment';
import 'react-datepicker/dist/react-datepicker.css';
import {Link} from 'react-router-dom';
import Swal from 'sweetalert2'
import GoogleUpload from "./GoogleUpload.js";
import InvalidAccessOrLogin from '../errorsPage/InvalidAccessOrLogin';
import Errors from '../common/Errors';


class SignatureRequestDetail extends Component {

    constructor(props) {
        super(props);
        this.state={
            id: null,
            selectedTemplateId:'',
            eSignaturTemplate: {},
            redirectToNotFoundPage:false,
            redirectToErrorPage:false,
            redirectToForbiddenPage: false,
            staff:{},
            activities:[],
            showLoader:false,
            showSpinnerLoader:false,
            isOriginal:false,
            isUpdated:false,
            isGoogleDriveEnable:false,
            canTakePayment:false,
            showDiv:false, /*show hide advanced setting variable*/
            apiStatus: {
                isError: false,
                message: ''
            }
        }
        this.validateValue = this.validateValue.bind(this);
        this.fetchSignatureById = this.fetchSignatureById.bind(this);
        this.handleResendEmail = this.handleResendEmail.bind(this);
        this.refreshPageData = this.refreshPageData.bind(this);
        this.handleShowAdvanceOptions = this.handleShowAdvanceOptions.bind(this);
    }
    /*show hide advanced setting function*/
    handleShowAdvanceOptions(){
        this.setState({showDiv: !this.state.showDiv})
    }

    validateValue(value,type) {
        if(value === "" || value === '' || value === null || value === 'null' || value === 'NULL' || value === 'undefined' || value === undefined){
            return false
        }
        if(type === "N"){
            if(isNaN(value) === true){
                return false
            }
        }
        return true
    }
    componentDidMount(){
        this.fetchSignatureById();
    }
    fetchSignatureById(){
        if(this.props.tid && this.validateValue(this.props.tid.id,"S") === true){
            this.setState({selectedTemplateId:this.props.tid.id});
            this.setState({showLoader:true});
            fetch(this.props.api + '/signature/'+this.props.tid.id, {
                method: 'GET',
                mode: 'cors',
                headers: {
                    'X-AUTH-TOKEN': this.props.jwtToken
                }
            })
                .then(response => response.json())
                .then(json => {
                    console.log(json);
                    if (json.timeOut === true && json.httpCode === 401 && json.isError === true) {
                        this.setState({showLoader: false});
                        this.props.onLogoutClick(json.message);
                    } else if (json.message === "Unauthorized Access!" && json.isError === true) {
                        this.setState({showLoader: false, redirectToErrorPage: true});
                    } else if (json.message === "Signature Request not found" && json.isError === true) {
                        this.setState({showLoader: false, redirectToNotFoundPage: true});
                    } else if (json.httpCode === 403 && json.isError === true && json.message === "Forbidden") {
                        this.setState({showLoader: false, redirectToForbiddenPage: true});
                    } else{
                        this.setState({
                            eSignaturTemplate: json.eSignatureRequest ? json.eSignatureRequest : {},
                            activities: json.eSignatureRequest ? json.eSignatureRequest.activities : [],
                            isGoogleDriveEnable: json.isGoogleDriveEnable,
                            canTakePayment: json.canTakePayment
                        });
                        this.setState({showLoader: false});
                    }
                }).catch(error => {
                console.log(error)
                this.setState({showLoader:false});
            });
        }

    }
    refreshPageData(event) {
        this.setState({ id: '' });
        this.setState({ selectedTemplateId:'' });
        this.setState({ eSignaturTemplate: {} });
        this.setState({ staff:{} });
        this.setState({ activities:[] });
        this.setState({ showLoader:true });
        this.setState({ showSpinnerLoader:false });
        this.setState({ isOriginal:false });
        this.setState({ isUpdated:false });
        this.componentDidMount();
    }
    handleResendEmail(esignId, recipientId){
        let url = this.props.api+'/signature/resendToRecipient';
        Swal.fire({
            title: 'Are you sure?',
            text: 'This will resend the Esignature Request to mentioned recipients',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes, Re-Send it!',
            cancelButtonText: 'No'
        }).then((result) => {
            if (result.value) {
                this.setState({showLoader:true});
                let body = {
                    esignId: esignId,
                    recipientId: recipientId
                };
                fetch(url, {
                    body: JSON.stringify(body),
                    method: "POST",
                    mode: 'cors',
                    headers: {
                        'X-AUTH-TOKEN': this.props.jwtToken,
                        'content-type': 'application/json'
                    }
                })
                .then(response => response.json())
                .then(json => {
                    console.log(json);
                    if (json && json.isError === false){
                        const {apiStatus}  = this.state;
                        apiStatus.isError = false;
                        apiStatus.message = json.message;
                        this.setState({ apiStatus: apiStatus})
                        this.setState({showLoader:false});
                    }else{
                        const {apiStatus}  = this.state;
                        apiStatus.isError = true;
                        apiStatus.message = json.message;
                        this.setState({disabledButton: true, apiStatus: apiStatus});
                        this.setState({showLoader:false});
                        if (json.timeOut === true && json.httpCode === 401 && json.isError === true) {
                            this.props.onLogoutClick(json.message);
                        }
                    }

                }).catch(error => {
                    console.log(error)
                    this.setState({showLoader:false});
                });
            } else if (result.dismiss === Swal.DismissReason.cancel) {
            }
        })
    }

    handleCancelSignatureRequest(event){
        let url = this.props.api + '/signature/' + this.state.eSignaturTemplate.id + '/cancel';
        Swal.fire({
            title: 'Confirm cancellation of this signature request. This cannot be undone.',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes',
            cancelButtonText: 'No',
            confirmButtonColor: "#1ab394"
        }).then((result) => {
            if (result.value) {
                this.setState({showLoader: true});
                fetch(url, {
                    method: "PUT",
                    mode: 'cors',
                    headers: {
                        'X-AUTH-TOKEN': this.props.jwtToken,
                        'content-type': 'application/json'
                    }
                })
                    .then(response => response.json())
                    .then(json => {
                        console.log(json);
                        if (json && json.isError === false){
                            this.refreshPageData(null);
                            const {apiStatus}  = this.state;
                            apiStatus.isError = false;
                            apiStatus.message = json.message;
                            this.setState({ apiStatus: apiStatus})
                            this.setState({showLoader:false});
                        }else{
                            const {apiStatus}  = this.state;
                            apiStatus.isError = true;
                            apiStatus.message = json.message;
                            this.setState({disabledButton: true, apiStatus: apiStatus});
                            this.setState({showLoader:false});
                            if (json.timeOut === true && json.httpCode === 401 && json.isError === true) {
                                this.props.onLogoutClick(json.message);
                            }
                        }

                    }).catch(error => {
                    console.log(error)
                    this.setState({showLoader:false});
                });
            } else if (result.dismiss === Swal.DismissReason.cancel) {
            }
        })
    }
    render() {
        let _this = this;
        let reviewUrl = _this.props.backEndServerUrl + '/esignature/reviewEsignatureRequest?es=' + _this.state.eSignaturTemplate.id + '&rId=';
        return(

            <div className="wrapper wrapper-content">
                <InvalidAccessOrLogin jwtToken={this.props.jwtToken}
                                      redirectToErrorPage={this.state.redirectToErrorPage}
                                      redirectToNotFoundPage={this.state.redirectToNotFoundPage}
                                      redirectToForbiddenPage={this.state.redirectToForbiddenPage}/>
                <div className="row">
                    <div className="col-lg-12">
                        <div className="wrapper wrapper-content animated fadeInUp" style={{padding: "2px 2px 10px"}}>
                            <div className="ibox">
                                <div className="ibox-content">
                                    <div className="row">
                                        <div className="col-lg-12">
                                            <div className="ibox float-e-margins">
                                                <div className="form-inline">
                                                    {this.state.eSignaturTemplate.status !== "CANCELLED"?
                                                        <div className="form-group" style={{marginRight: "3px"}}>
                                                            <a className="btn btn-primary"
                                                               onClick={this.refreshPageData}>
                                                                {_this.props.msg('form.label.refresh')}
                                                            </a>
                                                        </div>:""
                                                    }
                                                    <div className="form-group">
                                                        {this.state.eSignaturTemplate.attachments && this.state.eSignaturTemplate.attachments.map(function (files, index) {
                                                            return (
                                                    <div key={Math.random()}>
                                                        {files.updatedPdfFileName ?
                                                            <form style={{marginRight: "3px"}}
                                                                action={_this.props.backEndServerUrl + '/login/downloadFileByToken'}
                                                                method="post">
                                                                <input type="hidden" name="signatureRequestId" value={_this.state.eSignaturTemplate.id}/>
                                                                <input type="hidden" name="attachmentId" value={files.id}/>
                                                                <input type="hidden" name="token" value={_this.props.jwtToken}/>
                                                                <input type="submit" value="Download" className="btn btn-primary" style={{color: 'white', fontSize: "13px"
                                                                       }} name="Download"/>
                                                            </form>:
                                                            <span></span>
                                                        }
                                                    </div>
                                                            );
                                                        })}
                                                    </div>

                                                    <div className="form-group" >
                                                        {this.state.eSignaturTemplate.attachments && this.state.eSignaturTemplate.attachments.map(function (files, index) {
                                                            return (
                                                                <div key={Math.random()}>
                                                                    {files.updatedPdfFileName ?
                                                                        <div key={Math.random()} >
                                                                            {_this.state.isGoogleDriveEnable ?
                                                                                <div style={{marginRight: "3px"}}>
                                                                                <GoogleUpload
                                                                                dataSource={_this.props.backEndServerUrl + '/login/downloadFileByToken?signatureRequestId=' + _this.state.eSignaturTemplate.id +
                                                                                    '&attachmentId=' + files.id + '&token=' + _this.props.jwtToken + '&Download=Download'}
                                                                                    fileName={files.updatedPdfFileName}
                                                                                    siteName={_this.props.backEndServerUrl}
                                                                                    divId={'savetodrive-div'}
                                                                                    backendUrl={_this.props.backEndServerUrl}
                                                                                    originalFileName={files.originalName}
                                                                                    attachmentId={files.id}
                                                                                    signatureId={_this.state.eSignaturTemplate.id}
                                                                                    jwtToken={_this.props.jwtToken}
                                                                                    api={_this.props.api}
                                                                                /></div>
                                                                                : ''}
                                                                        </div>
                                                                        :
                                                                        <span></span>
                                                                    }
                                                                </div>
                                                            );
                                                        })}
                                                    </div>
                                                    <div className="form-group">
                                                        {this.state.eSignaturTemplate.status === "DRAFT"?
                                                            <form  style={{marginRight:"3px"}} action={_this.props.backEndServerUrl+'/login/authenticateByToken'} method="post" >
                                                                <input type="hidden" name="token" value={this.props.jwtToken} />
                                                                <input type="hidden" name="pageUrl" value={"/esignature/esignatureRequestEdit?id="+this.state.eSignaturTemplate.id}/>
                                                                <input type="hidden" name="erpRequest" value="true" />
                                                                <input type="submit" value= {_this.props.msg('form.label.editEsignature')} className="btn btn-primary" name="Save And Send" />
                                                            </form>
                                                            : this.state.eSignaturTemplate.status !== "CANCELLED"?
                                                                <form  style={{marginRight:"3px"}} ref="form"
                                                            action={_this.props.backEndServerUrl + '/login/authenticateByToken'} method="post" >
                                                            <input type="hidden" name="token" value={this.props.jwtToken} />
                                                            <input type="hidden" name="pageUrl" value={"/esignature/prepareSignatureDocument?eSignId=" + this.state.eSignaturTemplate.id}/>
                                                            <input type="hidden" name="erpRequest" value="true" />
                                                            <input type="submit" value={_this.props.msg('form.label.viewEsignature')} className="btn btn-primary" name="View E-Signature"/>
                                                            </form>:""
                                                        }
                                                    </div>
                                                    <div className="form-group" style={{marginRight:"6px"}}>
                                                        {this.state.eSignaturTemplate.status !== "SIGNED" && this.state.eSignaturTemplate.status !== "CANCELLED"?
                                                            <a onClick={this.handleCancelSignatureRequest.bind(this)} className="btn btn-gray">Cancel Signature</a> : ""
                                                        }
                                                    </div>
                                                    {this.state.eSignaturTemplate.status === "SIGNED" && this.state.canTakePayment?
                                                            <div className="form-group" style={{marginRight: "6px"}}>
                                                                <Link
                                                                    to={'/signature/processPayment/' + this.state.eSignaturTemplate.id}
                                                                    className="btn btn-primary">{_this.props.msg('payment.processPaymentBtn')}</Link>
                                                            </div> : ""
                                                    }
                                                </div>
                                                <div style={{'textAlign':'center'}}>
                                                    <Errors errorObject={this.state.apiStatus}/>
                                                    <br/>
                                                </div>
                                            </div>

                                            {this.state.showLoader === true ? (<div className="loading">Loading&#8230;</div>) : ''}

                                           <div className="col-lg-5">
                                               <dl className="dl-horizontal" style={{marginBottom:"2px"}}>
                                                   <dt>Status:</dt>

                                                   {this.state.eSignaturTemplate.status === "SIGNED"?
                                                       <dd style={{color: '#228B22', fontWeight:'bold'}}><span
                                                           className="">SIGNED</span></dd>
                                                       :null}
                                                   {this.state.eSignaturTemplate.status === "PROCESSING"?
                                                       <dd style={{color:'#f8ac59', fontWeight:'bold'}}><span
                                                           className="">PROCESSING</span></dd>
                                                       :null}
                                                   {this.state.eSignaturTemplate.status === "PENDING"?
                                                       <dd style={{color:'#7fa2ead9', fontWeight:'bold'}}><span
                                                           className="">PENDING</span></dd>
                                                       :null}
                                                   {this.state.eSignaturTemplate.status === "DRAFT"?
                                                       <dd style={{color:'#23c6c8', fontWeight: 'bold'}}><span
                                                           className="">DRAFT</span></dd>
                                                       :null}
                                                   {this.state.eSignaturTemplate.status === "CANCELLED"?
                                                       <dd style={{color:'#a9a9a9', fontWeight:'bold'}}><span
                                                           className="">CANCELLED</span></dd>
                                                       :null}
                                               </dl>
                                                <dl className="dl-horizontal" style={{marginBottom:"2px"}}>
                                                    <dt>{_this.props.msg('eSignatureDetails.header.emailSubject')}:</dt>
                                                    <dd className="">{this.state.eSignaturTemplate.emailTitle}</dd>

                                                    <dt>Description:</dt>
                                                    <dd>{this.state.eSignaturTemplate.description}</dd>

                                                    <dt>{_this.props.msg('table.th.createdBy')}:</dt>
                                                    <dd>{this.state.eSignaturTemplate.createdBy}</dd>
                                                {/*    <dt>{_this.props.msg('table.th.achCardOptional')}:</dt>
                                                    <dd>
                                                        {this.state.eSignaturTemplate.eitherAchOrCardRequired === true ? (
                                                            <i className="fa fa-check" style={{color:'#1ab394'}}/>) : (
                                                            <i className="fa fa-times" style={{color:'#ed5565'}}/>)}
                                                    </dd>*/}


                                                </dl>
                                            </div>
                                            <div className="col-lg-5">
                                                <dl className="dl-horizontal">
                                                    <dt>{_this.props.msg('table.th.created')}:</dt>
                                                    <dd>
                                                        {moment(this.state.eSignaturTemplate.dateCreated).format("MM/DD/YYYY hh:mm:ss")}
                                                    </dd>
                                                    <dt>{_this.props.msg('table.th.lastUpdated')}:</dt>
                                                    <dd>
                                                        {moment(this.state.eSignaturTemplate.lastUpdated).format("MM/DD/YYYY hh:mm:ss")}
                                                    </dd>
                                                    <dt>{_this.props.msg('table.th.senttorecipient')}:</dt>
                                                    <dd>
                                                        {this.state.eSignaturTemplate.sentDate? moment(this.state.eSignaturTemplate.sentDate).format("MM/DD/YYYY hh:mm:ss"):'Not yet sent'}
                                                    </dd>

                                                  {/*  <dt>{_this.props.msg('table.th.signingOrder')}:</dt>
                                                    <dd>
                                                        {this.state.eSignaturTemplate.enableSigningOrder === true?(<i class ="fa fa-check" style={{color:'#1ab394'}}/>):(
                                                            <i className="fa fa-times" style={{color:'#ed5565'}}/>)}
                                                    </dd>
                                                    <dt>{_this.props.msg('table.th.processPayment')}:</dt>
                                                    <dd>
                                                        {this.state.eSignaturTemplate.processPaymentAfterSigning === true ? (
                                                            <i className="fa fa-check" style={{color:'#1ab394'}}/>) : (
                                                            <i className="fa fa-times" style={{color:'#ed5565'}}/>)}
                                                    </dd>*/}



                                                </dl>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col-lg-12">
                                            <table className="table table-bordered dataTables-example"
                                                   style={{fontSize: '13px',marginBottom: "10px"}}>
                                                <caption style={{fontWeight:'900'}}>{_this.props.msg('table.th.recipients')}</caption>
                                                <thead>
                                                <tr>
                                                    {(this.state.eSignaturTemplate && this.state.eSignaturTemplate.enableSigningOrder === true) ?
                                                        <th style={{width: '30px',padding: "3px"}}>Sr.</th>
                                                         : null}
                                                    <th style={{width: '150px',padding: "3px"}}>{_this.props.msg('table.th.name')}</th>
                                                    <th style={{width: '100px',padding: "3px"}}>Email</th>
                                                    <th style={{width: '70px',padding: "3px"}} >{_this.props.msg('table.th.status')}</th>
                                                    <th style={{width: '70px',padding: "3px"}} >{_this.props.msg('table.th.type')}</th>
                                                    <th style={{width: '150px',padding: "3px"}} >{_this.props.msg('table.th.action')}</th>


                                                </tr>
                                                </thead>
                                                <tbody>
                                                {this.state.eSignaturTemplate.recipients && this.state.eSignaturTemplate.recipients.map(function (recipient, index) {
                                                    return (
                                                        <tr key={Math.random()} className="gradeX">
                                                            {(_this.state.eSignaturTemplate && _this.state.eSignaturTemplate.enableSigningOrder === true) ?
                                                                <td style={{padding: "3px"}}>{recipient.orderValue}</td>
                                                                : null}
                                                            <td style={{padding: "3px"}} >{recipient.name}</td>
                                                            <td style={{padding: "3px"}}>{recipient.email}</td>
                                                            <td style={{padding: "3px"}}>
                                                                {
                                                                    recipient.status === "SIGNED" ? <p className="" style={{color: '#228B22', fontWeight:'bold'}}>{recipient.status}</p>:null
                                                                }

                                                                {recipient.status === "PROCESSING" ?
                                                                    <p className="" style={{color:'#f8ac59', fontWeight:'bold'}}>PROCESSING</p>
                                                                    : null}
                                                                {recipient.status === "PENDING" ?
                                                                    <p className="" style={{color:'#7fa2ead9', fontWeight:'bold'}}>PENDING</p>
                                                                    : null}
                                                                {recipient.status=== "DRAFT" ?
                                                                    <p className="" style={{color:'#23c6c8', fontWeight:'bold'}}>DRAFT</p>
                                                                    : null}
                                                                {recipient.status === "CANCELLED" ?
                                                                    <p className="" style={{color:'#a9a9a9', fontWeight:'bold'}}>CANCELLED</p>
                                                                    : null}
                                                            </td>
                                                            <td style={{padding: "3px"}}>
                                                                {recipient.isSigner === true ? "Signer": "CC"}
                                                            </td>
                                                            {/*<td>{recipient.accessCode}</td>*/}
                                                            <td style={{padding: "3px"}}>

                                                                {recipient.isSigner === true && recipient.status !== "SIGNED" &&  _this.state.eSignaturTemplate.status === "CANCELLED" && recipient.status !== "CANCELLED"?
                                                                    "Not Applicable"
                                                                    :""}

                                                                {recipient.isSigner === true && recipient.status !== "SIGNED" && _this.state.eSignaturTemplate.status !== "CANCELLED" && recipient.status !== "CANCELLED"?
                                                                    <a href={reviewUrl+recipient.uniqueIdentifier} target="_blank" style={{textDecoration: 'underline'}}>{_this.props.msg('form.label.review')}</a>
                                                                    :""}
                                                                {_this.state.eSignaturTemplate.status !== "SIGNED" && _this.state.eSignaturTemplate.status !== "CANCELLED" &&
                                                                recipient.isSigner === true && recipient.status !== "SIGNED" ?
                                                                    " / " : ""
                                                                }
                                                                {_this.state.eSignaturTemplate.status !== "SIGNED" && _this.state.eSignaturTemplate.status !== "CANCELLED" && recipient.isSigner === true && recipient.status !== "SIGNED" ?
                                                                    <a onClick={(e)=>_this.handleResendEmail(_this.state.eSignaturTemplate.id, recipient.id)} title="Re-Send" style={{textDecoration: 'underline'}}>
                                                                        {_this.props.msg('form.label.reSend')}
                                                                    </a>:""
                                                                }
                                                                {recipient.status === "SIGNED" && recipient.isSigner === true ? "Not Applicable" : ""

                                                                }
                                                                {recipient.isSigner === false ? "Not Applicable" : ""}
                                                                {recipient.isRequester === true ? <label style={{color:'green', marginLeft:'20px'}}>&nbsp;(Requester)</label>: ""}

                                                            </td>
                                                        </tr>
                                                    );
                                                })}
                                                </tbody>
                                            </table>

                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-lg-12">
                                            <div className="panel blank-panel">
                                                <div className="panel-body">
                                                    <div className="tab-content">
                                                        <div className="tab-pane table-responsive" style={{display: 'block', "maxHeight":"500px"}}>
                                                            <table className="table" style={{fontSize: '13px'}}>
                                                                <thead>
                                                                <tr>
                                                                    <th>{_this.props.msg('table.th.activty')}</th>
                                                                    <th>{_this.props.msg('table.th.time')}</th>
                                                                </tr>
                                                                </thead>
                                                                <tbody>
                                                                {this.state.activities && this.state.activities.map(function (activity, index) {
                                                                    return (
                                                                        <tr key={index}>
                                                                            <td className="text-break" style={activity.isError ? { color: 'red' } : {}} >
                                                                                <div dangerouslySetInnerHTML={{ __html: activity.description }} />
                                                                            </td>
                                                                            <td className="text-break" style={activity.isError ? { color: 'red' } : {}} >
                                                                                {moment(activity.dateCreated).format("MM/DD/YYYY HH:mm:ss")}
                                                                            </td>
                                                                        </tr>
                                                                    );
                                                                })}
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <dl className="dl-horizontal" style={{marginBottom: "0px"}}>
                                            <dt style={{fontWeight:'100', textAlign:'left', marginLeft:'15px', fontSize:'11px'}}>{_this.props.msg('eSignatureDetails.header.originalAttachments')}
                                                :</dt>
                                            <dd style={{width: "100%", fontSize:'11px'}}>
                                                <ul className="list-unstyled">
                                                {this.state.eSignaturTemplate.attachments && this.state.eSignaturTemplate.attachments.map(function(files, index){
                                                    return(
                                                        <li key={Math.random()} >
                                                            <div style={{display: 'inline', whiteSpace: 'nowrap'}}>
                                                                {/* <a style={{fontSize:"11px", marginLeft:'-95px',textDecoration:"underline"}} title={files.originalName}
                                                                       href={_this.props.backEndServerUrl+'/login/downloadFileByToken?path=/'+(files.templateAttachmentId !== null ? 'templates/'+_this.state.eSignaturTemplate.templateId : _this.state.eSignaturTemplate.id)+'/'+(files.templateAttachmentId !== null ? files.templateAttachmentId : files.id)+
                                                                       '&fileName='+files.fileName+'&originalFileName='+files.originalName+'&token='+_this.props.jwtToken}>
                                                                        Download
                                                                    </a>*/}

                                                                <form action={_this.props.backEndServerUrl + '/login/downloadFileByToken'} method="post">
                                                                    <input type="hidden" name ="originalAttachment" value="true" />
                                                                    { files.templateAttachmentId !== null ?
                                                                        <input type="hidden" name="templateId" value={_this.state.eSignaturTemplate.templateId} />:
                                                                        <input type="hidden" name="signatureRequestId" value={_this.state.eSignaturTemplate.id} />
                                                                    }
                                                                    { files.templateAttachmentId !==null ?
                                                                        <input type="hidden" name="templateAttachmentId" value={files.templateAttachmentId} />:
                                                                        <input type="hidden" name="attachmentId" value={files.id} />

                                                                    }
                                                                    <input type="hidden" name="token" value={_this.props.jwtToken} />
                                                                    <input type="submit" value= "Download" name="Download" style={{fontSize:"11px", marginLeft:'-95px',textDecoration:"underline", backgroundColor:"white", border: "none"}}/>
                                                                </form>
                                                            </div>
                                                        </li>
                                                    );
                                                })}
                                                </ul>
                                            </dd>
                                        </dl>
                                    </div>
                                    <div className="row">
                                        <div className="col-lg-10"><a style={{textDecoration:"underline"}} onClick={this.handleShowAdvanceOptions}>Show/Hide Advanced Options</a></div>
                                        <div id="advancedSettingDiv" style={{display:this.state.showDiv===false?'none':'block'}}>
                                            <br/><br/>
                                            <div className="col-lg-5">
                                                <dl className="dl-horizontal" style={{marginBottom:"2px"}}>
                                                    <dt style={{width:'250px'}}>External CRM Id:</dt>
                                                    {this.state.eSignaturTemplate.crmId !== null?
                                                        <dd><span style={{marginLeft:"5px"}}>{this.state.eSignaturTemplate.crmId}</span></dd>
                                                        :<dd><span style={{marginLeft:"5px"}}>&nbsp;</span></dd>}
                                                </dl>
                                            <dl className="dl-horizontal" style={{marginBottom:"2px"}}>
                                            <dt style={{width:'250px'}}>External CRM Account Name:</dt>
                                                {this.state.eSignaturTemplate.crmAccountName !== null?
                                                <dd><span style={{marginLeft:"5px"}}>{this.state.eSignaturTemplate.crmAccountName}</span></dd>
                                                :<dd><span style={{marginLeft:"5px"}}>&nbsp;</span></dd>}
                                            </dl>
                                                <dl className="dl-horizontal" style={{marginBottom:"2px"}}>
                                                    <dt style={{width:'250px'}}>Template Id:</dt>
                                                    {this.state.eSignaturTemplate.templateId !== null?
                                                        <dd><span style={{marginLeft:"5px"}}>{this.state.eSignaturTemplate.templateId}</span></dd>
                                                        :<dd><span style={{marginLeft:"5px"}}>&nbsp;</span></dd>}
                                                </dl>
                                                <dl className="dl-horizontal" style={{marginBottom:"2px"}}>
                                                    <dt style={{width:'250px'}}>Html Template Id:</dt>
                                                    {this.state.eSignaturTemplate.htmlTemplateId !== null?
                                                        <dd><span style={{marginLeft:"5px"}}>{this.state.eSignaturTemplate.htmlTemplateId}</span></dd>
                                                        :<dd><span style={{marginLeft:"5px"}}>&nbsp;</span></dd>}
                                                </dl>
                                                <dl className="dl-horizontal" style={{marginBottom:"2px"}}>
                                                    <dt style={{width:'250px'}}>Disable Export Customer:</dt>
                                                    {this.state.eSignaturTemplate.disableExportCustomer === true?
                                                        <dd><span style={{marginLeft:"5px"}}>YES</span></dd>
                                                        :<dd><span  style={{marginLeft:"5px"}}>NO</span></dd>}
                                                </dl>
                                                <dl className="dl-horizontal" style={{marginBottom:"2px"}}>
                                                    <dt style={{width:'250px'}}>Allow Either ACH or Card:</dt>
                                                    {this.state.eSignaturTemplate.eitherAchOrCardRequired === true?
                                                        <dd><span style={{marginLeft:"5px"}}>YES</span></dd>
                                                        :<dd><span style={{marginLeft:"5px"}}>NO</span></dd>}
                                                </dl>
                                                <dl className="dl-horizontal" style={{marginBottom:"2px"}}>
                                                    <dt style={{width:'250px'}}>Enable Signing Order:</dt>
                                                    {this.state.eSignaturTemplate.enableSigningOrder === true?
                                                        <dd><span style={{marginLeft:"5px"}}>YES</span></dd>
                                                        :<dd><span style={{marginLeft:"5px"}}>NO</span></dd>}
                                                </dl>
                                                <dl className="dl-horizontal" style={{marginBottom:"2px"}}>
                                                    <dt style={{width:'250px'}}>Do not email attachment:</dt>
                                                    {this.state.eSignaturTemplate.doNotEmailAttachment === true?
                                                        <dd><span style={{marginLeft:"5px"}}>YES</span></dd>
                                                        :<dd><span style={{marginLeft:"5px"}}>NO</span></dd>}
                                                </dl>
                                                <dl className="dl-horizontal" style={{marginBottom:"2px"}}>
                                                    <dt style={{width:'250px'}}>Process Payment on signing:</dt>
                                                    {this.state.eSignaturTemplate.processPaymentAfterSigning === 'PROCESS_PAYMENT_AFTER_SIGNED'?
                                                        <dd><span style={{marginLeft:"5px"}}>YES</span></dd>
                                                        :<dd><span style={{marginLeft:"5px"}}>NO</span></dd>}
                                                </dl>
                                                <dl className="dl-horizontal" style={{marginBottom:"2px"}}>
                                                    <dt style={{width:'250px'}}>Create Order on Signing:</dt>
                                                    {this.state.eSignaturTemplate.createOrderOnSigning === true?
                                                        <dd><span style={{marginLeft:"5px"}}>YES</span></dd>
                                                        :<dd><span style={{marginLeft:"5px"}}>NO</span></dd>}
                                                </dl>
                                                <dl className="dl-horizontal" style={{marginBottom:"2px"}}>
                                                    <dt style={{width:'250px'}}>Create Invoice:</dt>
                                                    {this.state.eSignaturTemplate.createInvoice === true?
                                                        <dd><span style={{marginLeft:"5px"}}>YES</span></dd>
                                                        :<dd><span style={{marginLeft:"5px"}}>NO</span></dd>}
                                                </dl>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <style dangerouslySetInnerHTML={{
                        __html: `
                        .dashboard-page .ibox {
                            border-top: 0px solid white;
                        }
                        `
                    }}/>
                </div>
            </div>
        )
    }
}
export default SignatureRequestDetail;


// WEBPACK FOOTER //
// ./src/components/template/SignatureRequestDetail.js